import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sainsburys-tech/bolt';
import { formatPrice } from '@sainsburys-tech/boltui-utils';
import { InsuranceIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './CareAdded.styles';

var CareAdded = function CareAdded(_ref) {
  var title = _ref.title,
      price = _ref.price,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
      totalPrice = _ref.totalPrice,
      onRemove = _ref.onRemove,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(Styled.Wrapper, {
    "data-test": "".concat(dataTest, "-added")
  }, /*#__PURE__*/React.createElement(Styled.IconContainer, null, /*#__PURE__*/React.createElement(InsuranceIcon, {
    width: 48,
    height: 48
  })), /*#__PURE__*/React.createElement(Styled.ContentContainer, null, /*#__PURE__*/React.createElement(Styled.Title, {
    "data-test": "".concat(dataTest, "-title"),
    "data-quantity": quantity
  }, quantity > 1 ? "".concat(quantity, " x ").concat(title) : title), /*#__PURE__*/React.createElement(Styled.CTA, null, /*#__PURE__*/React.createElement(Button, {
    kind: "link",
    onClick: onRemove,
    "data-test": "".concat(dataTest, "-remove-cta")
  }, "Remove")), /*#__PURE__*/React.createElement(Styled.PriceWrapper, null, /*#__PURE__*/React.createElement(Styled.Price, {
    "data-test": "".concat(dataTest, "-price")
  }, formatPrice(totalPrice)), quantity > 1 && /*#__PURE__*/React.createElement(Styled.UnitPrice, {
    "data-test": "".concat(dataTest, "-unit-price")
  }, "unit price ", formatPrice(price)))));
};

CareAdded.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  totalPrice: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  'data-test': PropTypes.string
};
export default CareAdded;